var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMybasiqHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    overflow: "visible",
    width: "165pt",
    height: "23pt",
    viewBox: "0 0 659.74231 92.491158",
    id: "svg114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Document",
    fill: "none",
    stroke: "#000000",
    fontFamily: "'Times New Roman'",
    fontSize: "16px",
    transform: "matrix(1,0,0,-1,11.610656,-313.92312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spread",
    transform: "translate(0,-720)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 648.13167,346.63052 v -4.76841 h -6.07842 v -17.48333 h -5.21055 v 17.48333 h -6.07842 v 4.76841 z",
    fillRule: "nonzero",
    fill: "#b81802",
    strokeWidth: 0.735398,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403,
    id: "path85",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 615.13329,341.86211 v -4.76779 h 5.20988 c 1.15782,0 1.73707,0.52948 1.73707,1.58906 v 1.58905 c 0,1.0602 -0.57925,1.58968 -1.73707,1.58968 z m 3.47347,-9.5362 h -3.47347 v -7.94713 h -5.21056 v 22.25174 h 10.42044 c 4.6313,0 6.94695,-2.11916 6.94695,-6.35809 v -1.58905 c 0,-2.59557 -1.06544,-4.429 -3.19565,-5.49907 l 3.19565,-8.80553 h -5.20988 z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.735398,
    fill: "#b81802",
    fillRule: "nonzero",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403,
    id: "path87",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 593.4232,330.73686 c 0,-1.0602 0.57858,-1.58968 1.7364,-1.58968 h 4.34202 c 1.15783,0 1.7364,0.52948 1.7364,1.58968 v 9.53557 c 0,1.0602 -0.57857,1.58968 -1.7364,1.58968 h -4.34202 c -1.15782,0 -1.7364,-0.52948 -1.7364,-1.58968 z m 13.02538,0 c 0,-4.23893 -2.31566,-6.35808 -6.94696,-6.35808 h -4.34202 c -4.6313,0 -6.94696,2.11915 -6.94696,6.35808 v 9.53557 c 0,4.23893 2.31566,6.35809 6.94696,6.35809 h 4.34202 c 4.6313,0 6.94696,-2.11916 6.94696,-6.35809 z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.735398,
    fill: "#b81802",
    fillRule: "nonzero",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403,
    id: "path89",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 572.58165,341.86211 v -4.76779 h 5.20988 c 1.15783,0 1.73708,0.52948 1.73708,1.58906 v 1.58905 c 0,1.0602 -0.57925,1.58968 -1.73708,1.58968 z m 0,-9.5362 v -7.94713 h -5.21055 v 22.25174 h 10.42043 c 4.63131,0 6.94696,-2.11916 6.94696,-6.35809 v -1.58905 c 0,-4.23831 -2.31565,-6.35747 -6.94696,-6.35747 z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.735398,
    fill: "#b81802",
    fillRule: "nonzero",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403,
    id: "path91",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 563.89627,337.88854 v -4.76779 h -10.41976 v -3.97357 h 10.41976 v -4.7684 h -15.63032 v 22.25174 h 15.63032 v -4.76841 h -10.41976 v -3.97357 z m -31.26131,3.97357 v -4.76779 h 5.20988 c 1.15783,0 1.73708,0.52948 1.73708,1.58906 v 1.58905 c 0,1.0602 -0.57925,1.58968 -1.73708,1.58968 z m 3.47348,-9.5362 h -3.47348 v -7.94713 h -5.21055 v 22.25174 h 10.42043 c 4.63131,0 6.94696,-2.11916 6.94696,-6.35809 v -1.58905 c 0,-2.59557 -1.06544,-4.429 -3.19566,-5.49907 l 3.19566,-8.80553 h -5.20988 z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.735398,
    fill: "#b81802",
    fillRule: "nonzero",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403,
    id: "path93",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    strokeWidth: 0.954,
    fill: "#bf0000",
    strokeMiterlimit: 79.8403,
    transform: "matrix(0.67433096,0,0,0.61710965,40.30119,156.8769)",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 603.625,354.171 c -3.817,0 -6.679,-2.858 -7.637,-6.674 -8.591,-37.232 -8.591,-37.232 -8.591,-37.232 0,-1.908 0,-3.82 0.954,-4.774 0.955,-0.958 1.913,-1.909 3.817,-1.909 89.732,0 89.732,0 89.732,0 3.821,0 6.683,2.863 7.636,5.725 8.592,38.19 8.592,38.19 8.592,38.19 0,1.904 0,2.858 -0.951,4.77 -0.958,0.954 -2.87,1.904 -3.82,1.904 z m -40.094,-39.132 c -1.905,-8.594 0,-18.139 5.728,-24.821 5.729,-7.633 14.318,-11.456 22.909,-11.456 89.732,0 89.732,0 89.732,0 -5.724,-24.822 -5.724,-24.822 -5.724,-24.822 14.319,0 14.319,0 14.319,0 6.682,0 12.406,4.774 14.318,11.457 17.182,76.368 17.182,76.368 17.182,76.368 1.908,9.548 0,18.134 -5.729,25.774 -5.724,6.678 -14.319,11.454 -22.909,11.454 -91.641,0 -91.641,0 -91.641,0 -14.319,0 -25.771,-9.549 -29.596,-23.86 z",
    markerStart: "none",
    markerEnd: "none",
    id: "path95",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 516.754,278.762 c 13.369,0 13.369,0 13.369,0 6.682,0 13.36,4.774 14.319,11.456 20.043,88.775 20.043,88.775 20.043,88.775 -13.362,0 -13.362,0 -13.362,0 -6.681,0 -12.409,-4.776 -14.318,-11.454 z",
    markerStart: "none",
    markerEnd: "none",
    id: "path97",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 397.43,378.993 c -14.315,0 -25.775,-9.549 -28.633,-23.86 -0.954,-1.912 -0.954,-1.912 -0.954,-1.912 -1.913,-9.548 0,-18.139 5.724,-25.771 5.728,-6.687 14.323,-11.457 22.909,-11.457 84.008,0 84.008,0 84.008,0 1.908,0 2.859,0 3.816,-1.912 0.958,-0.954 1.909,-2.866 0.958,-3.816 0,-0.958 0,-0.958 0,-0.958 -0.958,-2.862 -3.824,-5.725 -7.636,-5.725 -108.825,0 -108.825,0 -108.825,0 -7.636,0 -13.365,-4.774 -15.273,-11.456 -2.866,-13.364 -2.866,-13.364 -2.866,-13.364 129.826,0 129.826,0 129.826,0 13.365,0 25.776,9.548 28.634,22.909 0.958,2.862 0.958,2.862 0.958,2.862 1.904,8.594 0,18.143 -5.733,25.779 -5.723,6.678 -14.311,10.498 -23.859,10.498 -84.008,0 -84.008,0 -84.008,0 -0.95,0 -2.858,0.955 -3.816,1.909 -0.954,1.908 -0.954,2.866 -0.954,4.778 0,0 0,0 0,0 0.954,3.816 3.82,6.674 7.636,6.674 71.598,0 71.598,0 71.598,0 6.682,0 13.36,4.779 14.318,11.461 2.863,13.361 2.863,13.361 2.863,13.361 z",
    markerStart: "none",
    markerEnd: "none",
    id: "path99",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 224.651,315.993 c -2.861,0 -5.728,-1.912 -6.678,-5.728 0,0 0,0 0,0 -0.962,-1.908 0,-3.82 0.95,-4.774 0.954,-0.958 1.913,-1.909 3.82,-1.909 89.729,0 89.729,0 89.729,0 3.82,0 6.682,2.863 6.682,5.725 0.959,0.958 0.959,0.958 0.959,0.958 0,0.95 0,2.862 -0.959,3.816 -0.95,1.912 -2.862,1.912 -3.816,1.912 z m 104.051,31.504 c -0.949,-3.824 -3.82,-6.687 -7.64,-6.687 -98.319,0 -98.319,0 -98.319,0 -13.369,0 -25.775,-9.544 -28.641,-22.905 -0.95,-2.866 -0.95,-2.866 -0.95,-2.866 -1.912,-8.594 0,-18.139 5.724,-24.821 5.729,-7.633 14.319,-11.456 23.867,-11.456 91.641,0 91.641,0 91.641,0 14.318,0 25.771,9.548 28.642,22.909 9.544,40.094 9.544,40.094 9.544,40.094 1.904,9.548 0,18.134 -5.728,25.774 -5.729,6.678 -14.323,11.454 -22.914,11.454 -74.455,0 -74.455,0 -74.455,0 -7.64,0 -13.365,-4.776 -15.277,-11.454 -2.862,-13.368 -2.862,-13.368 -2.862,-13.368 92.594,0 92.594,0 92.594,0 0.954,0 2.862,-0.95 3.825,-1.904 0.949,-1.912 0.949,-2.866 0.949,-4.77 z",
    markerStart: "none",
    markerEnd: "none",
    id: "path101",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.1,354.171 c -3.82,0 -6.683,-2.858 -7.636,-6.674 -8.592,-37.232 -8.592,-37.232 -8.592,-37.232 0,-1.908 0,-3.82 0.951,-4.774 0.958,-0.958 2.87,-1.909 3.82,-1.909 89.733,0 89.733,0 89.733,0 3.816,0 6.678,2.863 7.636,5.725 8.591,38.19 8.591,38.19 8.591,38.19 0,1.904 0,2.858 -0.955,4.77 -0.954,0.954 -1.911,1.904 -3.816,1.904 z m 0,24.822 c 5.724,24.825 5.724,24.825 5.724,24.825 -14.318,0 -14.318,0 -14.318,0 -6.683,0 -12.407,-4.779 -14.32,-11.453 -17.18,-77.326 -17.18,-77.326 -17.18,-77.326 -1.909,-8.594 0,-18.139 5.728,-24.821 5.724,-7.633 14.319,-11.456 22.909,-11.456 91.64,0 91.64,0 91.64,0 14.32,0 26.73,9.548 29.596,22.909 8.591,40.094 8.591,40.094 8.591,40.094 2.862,9.548 0,18.134 -5.728,25.774 -5.729,6.678 -14.319,11.454 -22.91,11.454 z",
    markerStart: "none",
    markerEnd: "none",
    id: "path103",
    style: {
      fill: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 49.054939,404.85567 h 7.814452 v -20.48389 c 7.86e-4,-5.46259 -3.472727,-8.19388 -10.41859,-8.19388 H 36.031397 v 6.14533 h 7.814451 c 3.47232,0 5.209091,0.68274 5.209091,2.04855 v 1.63902 c -1.041492,-1.09258 -2.778263,-1.63902 -5.209091,-1.63902 -6.94627,0 -10.418998,2.73161 -10.418998,8.19387 v 12.29002 h 7.814453 v -12.29002 c 0,-1.3658 0.867774,-2.04855 2.604545,-2.04855 2.430828,0 4.167599,0.34154 5.209091,1.02428 z",
    fillRule: "nonzero",
    fill: "#b81802",
    strokeWidth: 1.02303,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403,
    id: "path106",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -11.610656,405.28839 H -0.67091582 L 7.9252642,387.877 16.520634,405.28839 h 10.940155 v -28.67777 h -7.814455 v 17.4117 l -8.3352,-17.4117 H 4.5389942 l -8.3352,17.4117 v -17.4117 h -7.8144502 z",
    fillRule: "nonzero",
    fill: "#b81802",
    strokeWidth: 0.699524,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403,
    id: "path108",
    style: {
      fill: "#ffffff"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMybasiqHeaderLogo);
export default __webpack_public_path__ + "static/media/mybasiq_header_logo.099af49ef7078430b779139fab3cffa3.svg";
export { ForwardRef as ReactComponent };